import React from "react";
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from "../context/UserContext"

export default function RequireAccess({ component: Component, path, adminOnly = false }) {
    const userContext = useUser();
    const location = useLocation();
    const user = userContext.user;
    const accessStatus = user && (!adminOnly || user.isAdmin) && (user.isAdmin || user.routes === true ||
        (Array.isArray(user.routes) && user.routes.includes(path)));

    if (!accessStatus) {
        return <Navigate to="/" replace state={{ accessDenied: true, path }} />;
    }

    return <Component key={location.pathname} path={path} />;
}
